export const env = {
  DEV: {
    API_URL: `https://api.app.nftydoor.com/dev`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev",
  },
  LOCAL: {
    API_URL: `http://localhost:3000/dev-guls`,
    /** The smarty key is different for local development */
    SMARTY_KEY: "21102174564513388",
    ENV: "dev-guls",
  },
  FRANFG: {
    API_URL: `https://api.app.nftydoor.com/dev-fg`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-fg",
  },
  GIUL: {
    API_URL: `https://api.app.nftydoor.com/dev-guls`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-guls",
  },
  LEO: {
    API_URL: `https://api.app.nftydoor.com/dev-leo`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-leo",
  },
  LU: {
    API_URL: `https://api.app.nftydoor.com/dev-lu`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-lu",
  },
  LUCHO: {
    API_URL: `https://api.app.nftydoor.com/dev-lucho`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-lucho",
  },
  JUSTO: {
    API_URL: `https://api.app.nftydoor.com/dev-justo`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-justo",
  },
  MISAEL: {
    API_URL: `https://api.app.nftydoor.com/dev-misael`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-misael",
  },
  RYAN: {
    API_URL: `https://api.app.nftydoor.com/dev-ryan`,
    SMARTY_KEY: "118833480137188122",
    ENV: "dev-ryan",
  },
  PROD: {
    API_URL: `https://api.app.nftydoor.com/prod`,
    SMARTY_KEY: "118833480137188122",
    ENV: "prod",
  },
};

export const ENV = ((localStorage.getItem("currentEviroment") as string) ??
  "DEV") as keyof typeof env;

function getEnvVariable(key: keyof typeof env.DEV) {
  const isInProduction = process.env.REACT_APP_ENV === "prod";
  return env[isInProduction ? "PROD" : ENV][key];
}

export default getEnvVariable;
